import { useReactTable } from "@tanstack/react-table";
import ReactTableConfigBuilder from "./ReactTableConfigBuilder";
import { useState } from "react";

export default function useTable({ columns, data, config }) {
  const [tableData, setTableData] = useState(data);

  const tableConfig = new ReactTableConfigBuilder(tableData, columns);

  if (config?.pinnedColumns?.length) {
    tableConfig.setPinnedColumns(config.pinnedColumns);
  }

  const table = useReactTable(tableConfig.build());

  return { table, setTableData };
}
